__turbopack_context__.v({
  "head": "error-screens-module__lNQXdW__head",
  "pad": "error-screens-module__lNQXdW__pad",
});
